import { Icon } from '@types';

export const Camera = ({ customStyles, handleClick }: Icon) => {
	return (
		<svg
			className={customStyles}
			onClick={handleClick}
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 74.67 57.95"
		>
			<defs>
				<style>
					{
						'.cls-camera{fill:none;stroke:#2e2d2c;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}'
					}
				</style>
			</defs>
			<rect
				className="cls-camera"
				x={1}
				y={10.87}
				width={72.67}
				height={46.07}
				rx={4.05}
				ry={4.05}
			/>
			<path
				className="cls-camera"
				d="M21.01,10.87L25.74,2.75c.56-.96,1.93-1.75,3.04-1.75h17.11c1.11,0,2.48,.79,3.04,1.75l4.73,8.12"
			/>
			<line className="cls-camera" x1={10.01} y1={5.92} x2={15.58} y2={5.92} />
			<path
				className="cls-camera"
				d="M53.43,33.91c0,8.89-7.21,16.09-16.09,16.09s-16.09-7.21-16.09-16.09,7.21-16.09,16.09-16.09,16.09,7.21,16.09,16.09Z"
			/>
			<path className="cls-camera" d="M26.77,33.91c0-5.83,4.73-10.56,10.56-10.56" />
			<path
				className="cls-camera"
				d="M66.63,21.72c0,2.15-1.75,3.9-3.9,3.9s-3.9-1.75-3.9-3.9,1.75-3.9,3.9-3.9,3.9,1.75,3.9,3.9Z"
			/>
		</svg>
	);
};
